var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.645 4.312a4.478 4.478 0 1 0-6.333 6.333 4.478 4.478 0 0 0 6.333-6.333ZM2.897 2.897a6.478 6.478 0 0 1 9.815 8.4l3.995 3.996a1 1 0 0 1-1.414 1.414l-3.996-3.995a6.48 6.48 0 0 1-8.4-9.815Z",
  clipRule: "evenodd"
})));
export default SvgIconSearch;